import { Integration_Handler_Names_Enum } from '@main/graphql/types.generated';
import { z } from 'zod/v4';

import { IntegrationConfig } from '../../../../../../lib';
import { JiraService } from '../../service';

export type IssuesExportConfig = typeof IssuesExportConfig._.Config;

export const IssuesExportConfig = IntegrationConfig.make({
  service: JiraService,
  name: Integration_Handler_Names_Enum.IssuesExport,
  configSchema: z.object({
    jqlQuery: z.string().min(1),
    jqlQueryCheck: z.string().optional(),
  }),
});
